import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '../features/auth/AuthProvider';
import { useHasPermission } from '../features/auth/usePermission';
import styles from './ProtectedRoute.module.scss';

type ProtectedRouteProps = {
  permission?: string;
};

export function ProtectedRoute({ permission }: ProtectedRouteProps) {
  const auth = useAuth();
  const location = useLocation();
  const hasPermission = useHasPermission(permission ?? '');

  if (auth.isInitializing) {
    return (
      <div className={styles.loading}>
        <div className={styles.spinner} />
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (permission && !hasPermission) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Outlet />;
}
